import './index.css'
import cn from 'clsx'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { sendMixpanelEvent } from '@disco/state-management/actions/AnalyticsActions'
import { toggleShortlists } from '@disco/state-management/actions/AppActions'
import {
  uploadProviderFiles,
  uploadsCancel,
} from '@disco/state-management/actions/shortlist-upload-actions'
import * as ShortlistActions from '@disco/state-management/actions/ShortlistActions'
import { isDeviceTypePhone } from '@disco/state-management/selectors/app'
import { getSearchHeight } from '@disco/state-management/selectors/search'
import {
  getShortlistsUploadStatus,
  getVisibleShortlistIds,
} from '@disco/state-management/selectors/shortlists'
import Shortlist from 'components/shortlist'
import { Spinner } from 'components/ui'
import Button from 'components/ui/button'
import Heading from 'components/ui/heading'
import { Flex } from 'components/ds'
import CustomScrollbars from 'components/ui/scrollbar'
import ShortlistStackError from './shortlist-stack-error' // TODO: Rename to Shortlist
import type { RootState } from 'store/configureStore'
import PlaylistCreator from './playlist-creator'

class ShortlistStack extends Component<any> {
  _shortlistStack: any

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.shortlistIds.length === 0 && nextProps.loaded)
      this.props.createNewShortlist()
  }

  componentDidMount() {
    if (this.props.shortlistIds.length === 0 && this.props.loaded)
      this.props.createNewShortlist()
  }

  componentWillUnmount() {
    this.props.uploadsCancel()
  }

  componentDidUpdate(prevProps) {
    const { shortlistActivation, loading } = this.props

    if (
      loading ||
      !shortlistActivation ||
      prevProps.shortlistActivation === shortlistActivation
    ) {
      return
    }

    const container = this._shortlistStack._scrollbars.view
    const target = document.getElementById(`Shortlist_${shortlistActivation}`)
    if (!target) return
    const containerBounds = container.getBoundingClientRect()
    const itemBounds = target.getBoundingClientRect()

    if (
      itemBounds.top <= containerBounds.top ||
      itemBounds.top >= containerBounds.bottom
    ) {
      const prevScrollPosition = container.scrollTop

      this._shortlistStack.scrollTop(
        -containerBounds.top + prevScrollPosition + itemBounds.top,
      )
    }
  }

  _handleClick = () => {
    this.props.sendMixpanelEvent('Playlist Creator - Create new playlist')
    this.props.createNewShortlist()
  }

  _toggleSidebarExpansion = () => {
    const { isSearchPage } = this.props
    const currentLocation = isSearchPage ? 'Search' : 'Explorer'
    this.props.toggleShortlists(undefined, currentLocation, 'Click Button')
  }

  render() {
    const {
      shortlistsOpen,
      loading,
      shortlistsOffset,
      isPhone,
      windowWidth,
      shortlistError,
      searchPageShortlistOpen,
      isSearchPage,
      isBannerVisible,
    } = this.props

    const list = this.props.shortlistIds.map(id => (
      <Shortlist
        key={id}
        uploadFiles={this._handleUpload}
        shortlistId={id}
        flash={this.props.shortlistActivation === id}
      />
    ))
    const shortlistsClassName = loading
      ? 'custom-scrollbars-parent ShortlistStack_ShortlistsLoading'
      : 'custom-scrollbars-parent ShortlistStack_Shortlists'
    const stackClassName = cn('ShortlistStack e2r-cont', {
      'shortlists-open': isSearchPage
        ? searchPageShortlistOpen
        : shortlistsOpen,
    })
    const stackStyle = {
      top:
        shortlistsOffset && !isPhone && windowWidth < 1024
          ? shortlistsOffset
          : undefined,
    }

    const renderShortlist = () => {
      return (
        <Flex className={stackClassName}>
          <Flex direction="column" className={shortlistsClassName}>
            {this._renderNewShortlist()}
            {loading ? (
              <Spinner />
            ) : (
              <CustomScrollbars
                className="ShortlistStack_ShortlistsScroll"
                vertical
                color="dark"
                ref={r => {
                  this._shortlistStack = r
                }}
                dndScrolling
              >
                {!shortlistError ? (
                  <Flex direction="column">{list}</Flex>
                ) : (
                  <ShortlistStackError error={shortlistError} />
                )}
              </CustomScrollbars>
            )}
          </Flex>
        </Flex>
      )
    }
    return (
      <Flex style={stackStyle}>
        <PlaylistCreator
          visible={isSearchPage ? searchPageShortlistOpen : shortlistsOpen}
          onClose={this._toggleSidebarExpansion}
          isPhone={isPhone}
          isBannerVisible={this.props.isBannerVisible}
        >
          {renderShortlist()}
        </PlaylistCreator>
      </Flex>
    )
  }

  _handleUpload = (...args) => {
    this.props.uploadProviderFiles(...args)
  }
  _handleCancelUpload = () => {
    this.props.uploadsCancel()
  }

  _renderMobileAddButton() {
    const { isPhone } = this.props
    if (!isPhone) return null
    return (
      <Button
        caption="Create Playlist"
        compact
        disabled={this.props.loading}
        onClick={this._handleClick}
      />
    )
  }

  _renderDesktopAddButton() {
    const { isPhone } = this.props
    if (isPhone) return null
    return (
      <svg fill="currentcolor" width="24" height="24">
        <circle
          className="ShortlistStack_Header_Add_Circle"
          cx="12"
          cy="12"
          r="10"
          opacity="0"
        />
        <path
          className="ShortlistStack_Header_Add_Border"
          d="M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 12,2 Z M12,20 C7.59,20 4,16.41 4,12 C4,7.59 7.59,4 12,4 C16.41,4 20,7.59 20,12 C20,16.41 16.41,20 12,20 Z"
        />
        <path
          className="ShortlistStack_Header_Add_Plus"
          d="M12,7 C11.45,7 11,7.45 11,8 L11,11 L8,11 C7.45,11 7,11.45 7,12 C7,12.55 7.45,13 8,13 L11,13 L11,16 C11,16.55 11.45,17 12,17 C12.55,17 13,16.55 13,16 L13,13 L16,13 C16.55,13 17,12.55 17,12 C17,11.45 16.55,11 16,11 L13,11 L13,8 C13,7.45 12.55,7 12,7 Z"
        />
      </svg>
    )
  }

  _renderNewShortlist() {
    const { isPhone } = this.props
    return (
      <Flex
        className="ShortlistStack_Header radix-themes dark"
        data-gray-color="slate"
      >
        <Heading size={500}>Playlist Creator</Heading>
        {!this.props.shortlistError && isPhone && (
          <div className="ShortlistStack_Header_Add" data-testid="shortlist-stack-add">
            {this.props.shortlistsUploadStatus && isPhone
              ? null
              : this._renderMobileAddButton()}
          </div>
        )}
        {!this.props.shortlistError && !isPhone && (
          <div
            className={cn('ShortlistStack_Header_Add', {
              'is-disabled': this.props.loading,
            })}
            data-testid="shortlist-stack-add"
            onClick={this._handleClick}
          >
            {this.props.shortlistsUploadStatus && isPhone
              ? null
              : this._renderDesktopAddButton()}
          </div>
        )}
        {this.props.shortlistsUploadStatus && (
          <>
            {isPhone ? (
              <div className="ShortlistStack_CancelUploadBtn">
                <Button
                  caption="Uploading... / Cancel"
                  onClick={this._handleCancelUpload}
                  compact
                />
              </div>
            ) : (
              <button
                className="ShortlistStack_CancelUploadBtn"
                onClick={this._handleCancelUpload}
              >
                Uploading... / Cancel
              </button>
            )}
          </>
        )}
      </Flex>
    )
  }
}

export default connect(
  (state: RootState) => ({
    isPhone: isDeviceTypePhone(state),
    windowWidth: state.app.windowWidth,
    loading: state.shortlists.loading,
    loaded: state.shortlists.loaded,
    shortlistError: state.shortlists.error,
    shortlistIds: getVisibleShortlistIds(state),
    shortlistsUploadStatus: getShortlistsUploadStatus(state),
    shortlistsOpen: state.app.shortlistsOpen,
    searchPageShortlistOpen: state.app.isSearchPageShortlistOpen,
    shortlistsOffset: getSearchHeight(state),
    shortlistActivation: state.shortlists.shortlistActivation,
    isSearchPage: Boolean(window.location.pathname.includes('/search')),
  }),
  {
    ...ShortlistActions,
    uploadProviderFiles,
    uploadsCancel,
    sendMixpanelEvent,
    toggleShortlists,
  },
)(ShortlistStack)
